import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { Ng2ImgToolsService } from 'ng2-img-tools';
import { GlobalService } from '../../../../services/global.service';
import { ChatService } from '../../services/chat.service';

import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';
import * as firebase from 'firebase/app';

declare var $: any;

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {

  profileForm: FormGroup;
  image_file: any;
  resized_image_file: any;

  uploadPercent$: Observable<number>;
  downloadURL$: Observable<string>;
  downloaded_image_url: any;

  resizedUploadPercent$: Observable<number>;
  resizedDownloadURL$: Observable<string>;
  resized_image_url: any;

  profile_data = {
    name: '',
    email: '',
    mobile: '',
    pictureURL: '',
    pictureURLThumbnail: '',
    orgid: ''
  };

  constructor(
    private _formBuilder: FormBuilder,
    public _globalService: GlobalService,
    public _chatService: ChatService,
    private _ng2ImgToolsService: Ng2ImgToolsService
  ) { }

  ngOnInit() {
    // console.log('edit user profile', this._globalService.current_user_profile);
    if (this._globalService.current_user_profile && this._globalService.current_user_profile.meta) {
      this.profile_data.name = this._globalService.current_user_profile.meta.name ?
        this._globalService.current_user_profile.meta.name : '';
      this.profile_data.email = this._globalService.current_user_profile.meta.email ?
        this._globalService.current_user_profile.meta.email : '';
      this.profile_data.mobile = this._globalService.current_user_profile.meta.mobile ?
        this._globalService.current_user_profile.meta.mobile : '';
      this.profile_data.pictureURL = this._globalService.current_user_profile.meta.pictureURL ?
        this._globalService.current_user_profile.meta.pictureURL : '';
      this.profile_data.pictureURLThumbnail = this._globalService.current_user_profile.meta.pictureURLThumbnail ?
        this._globalService.current_user_profile.meta.pictureURLThumbnail : '';
      this.profile_data.orgid = this._globalService.current_user_profile.meta.orgid ?
        this._globalService.current_user_profile.meta.orgid : '';
    }

    this.createForm();
  }

  createForm() {
    this.profileForm = this._formBuilder.group({
      name: [null, [Validators.required]],
      email: [{ value: null, disabled: true }, [Validators.required]],
      employee_code: [{ value: null, disabled: true }, []],
      mobile: [null, []],
      designation: [{ value: null, disabled: true }, []]
    });
  }

  onChangeEvent(event) {
    this.image_file = event.target.files[0];
    // console.log(this.image_file, event);
    if (this.image_file.type.toString().includes('png') ||
      this.image_file.type.toString().includes('jpg') ||
      this.image_file.type.toString().includes('jpeg')) {

      if (this.image_file) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          $('#img-preview').attr('src', e.target.result);
        };

        reader.readAsDataURL(this.image_file);
        $('#input-fileid')[0].value = '';

        this.compressImage(this.image_file);

      }
    } else {
      $('#input-fileid')[0].value = '';
      this.image_file = null;
      this._globalService.openSnackBar('only jpg or png allowed', 'Dismiss');
    }
  }

  onUpdate() {
    this._globalService.global_loader = true;

    const user_meta_path = this._globalService.root_path + '/' + this._globalService.domain
      + '/users/' + this._globalService._fireAuth.auth.currentUser.uid + '/meta';

    if (this.downloaded_image_url) {
      this.profile_data.pictureURL = this.downloaded_image_url;
    }
    if (this.resized_image_url) {
      this.profile_data.pictureURLThumbnail = this.resized_image_url;
    }

    this.profile_data.name = (this.profile_data.name).toLowerCase();

    this._globalService._fireDB.object(user_meta_path)
      .update(this.profile_data)
      .then((resp) => {
        // console.log(resp);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar('Updated successfuly', 'Dismiss');

        this.image_file = null;

        // const current_user_profile = JSON.parse(localStorage.getItem('current_user_profile'));
        // current_user_profile.meta = this.profile_data;
        // localStorage.setItem('current_user_profile', JSON.stringify(current_user_profile));
        this._chatService.display_edit_profile = false;
      })
      .catch((err) => {
        // console.log('error: ' + err);
        this._globalService.global_loader = false;
        this._globalService.openSnackBar('Error Occured', 'Dismiss');
      });


      // searchIndex
    const serchIndexNamePath = this._globalService.root_path + '/' + this._globalService.domain + 
                            '/searchIndex/' + this._globalService._fireAuth.auth.currentUser.uid + '/name' ;
    const datasave = {};
    datasave[serchIndexNamePath] = this.profile_data.name;
    this._globalService.firebaseUpdate(datasave);
    // end search index

    // update display name
    firebase.auth().currentUser.updateProfile({
      displayName: this.profile_data.name,
      photoURL: ''
    }).then(function () {

    }).catch(function (error) {

    });
    // end

  }


  updateImage() {


    if (this.image_file) {
      this._globalService.global_loader = true;

      const file_path = this._globalService.root_path + '/' + this._globalService.domain
        + '/images/' + this._globalService._fireAuth.auth.currentUser.uid
        + '/picture';

      const fileRef = this._globalService._fireStorage.ref(file_path);
      const task = this._globalService._fireStorage.upload(file_path, this.image_file);

      // observe percentage changes
      this.uploadPercent$ = task.percentageChanges();
      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          // console.log('down url', fileRef.getDownloadURL());
          this.downloadURL$ = fileRef.getDownloadURL();
          this.downloadURL$.first().subscribe(data => {
            // console.log('upload data ', data);
            this.downloaded_image_url = data;
            this.updateResizedImage();
          });
        })
      )
        .subscribe(data => {
          // console.log('sub upload', data);
        },
        err => {
          // this.onUpdate();
        },
        () => {


        });

    } else {
      this.onUpdate();
    }

  }

  updateResizedImage() {
    const file_path = this._globalService.root_path + '/' + this._globalService.domain
      + '/images/' + this._globalService._fireAuth.auth.currentUser.uid
      + '/pictureThumbnail';

    const fileRef = this._globalService._fireStorage.ref(file_path);
    const task = this._globalService._fireStorage.upload(file_path, this.resized_image_file);

    // observe percentage changes
    this.resizedUploadPercent$ = task.percentageChanges();
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
      finalize(() => {
        // console.log('down url', fileRef.getDownloadURL());
        this.resizedDownloadURL$ = fileRef.getDownloadURL();
        this.resizedDownloadURL$.first().subscribe(data => {
          // console.log('upload data ', data);
          this.resized_image_url = data;
          this.onUpdate();
        });
      })
    )
      .subscribe(data => {
        // console.log('sub upload', data);
      },
      err => {
        // this.onUpdate();
      },
      () => {

      });
  }

  compressImage(image) {
    this._ng2ImgToolsService.compress([image], 0.3).subscribe(result => {
      // console.log('compress image', result);
      this.resizeImage(result);
    }, error => {
      this.resizeImage(image);
    });
  }

  resizeImage(image) {
    this._ng2ImgToolsService.resize([image], 200, 200).subscribe(result => {
      // console.log('resize image', result);
      this.resized_image_file = result;
    }, error => {
      this.resized_image_file = image;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/chat/sub-components/edit-profile/edit-profile.component.ts